import { TextLink } from "@ovotech/element";
import * as React from "react";

export const PrivacyPolicy = () => {
  return (
    <TextLink opensInNewWindow href="https://www.ovoenergy.com/privacy-policy">
      privacy policy
    </TextLink>
  );
};
